import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import QueryString from 'qs';
import { RootState } from "../../../store/rootReducer";
import { useSelector } from "react-redux";
import { ICreateNoticeInfo, IGetSubjects } from '../../../models/notification.model';
import useAxios from "../../../hooks/useAxios";
import { DatePicker, Select } from "antd";
import { useEffect, useState } from "react";
import { getSubjects2 } from "../../../api/notification.api";
import Loader from "../../Loader";
import ErrorResponse from "../../ErrorResponse";
import { Option } from "antd/lib/mentions";
import moment from "moment";
import Radio from "../../Radio";
import FileUpload from "../../FileUpload";
import Button from "../../Button";
import { IGetTimetables, ITimetable } from "../../../models/campusClasses3.model";
import { getTimetables } from "../../../api/campusClasses3.api";
import CustomTimePicker from "../../CustomTimePicker";

interface IProps {
    event: any;
    uniqueNo: number;
    dataList : Map<number, ICreateNoticeInfo>;
    setEachData : (data : Map<number, ICreateNoticeInfo>) => void;
    timeTables: ITimetable[]|undefined;
}

const NoticeMultilEditor = ({event, uniqueNo, dataList, setEachData, timeTables} : IProps) => {
    const { t } = useTranslation();
    const location = useLocation();
    const query = QueryString.parse(location.search, { ignoreQueryPrefix: true });
    const { auth } = useSelector((state: RootState) => state.auth);
    const { commonCodes } = useSelector((state: RootState) => state.commonCode);
    // NT0001 = 알림장 타입
    const NT0001 = commonCodes.find(item => item.commonCode === 'NT0001')?.detailCode;
    // NT0001 = 알림장 상세 타입
    const NT0002 = commonCodes.find(item => item.commonCode === 'NT0002')?.detailCode;
    const { data: res, isLoading, error, execute } = useAxios<IGetSubjects>();
    const { data: res2, isLoading : isLoading2, error : error2, execute : execute2 } = useAxios<IGetTimetables>();
    const { chosenClass } = useSelector((state: RootState) => state.class);
    
    const [subjectCode, setSubjectCode] = useState<number>();
    const [title, setTitle] = useState<string>();
    const [content, setContent] = useState<string>();
    const [alarmYN, setAlarmYN] = useState<string>();
    const [sms, setSms] = useState<any>(false) ;
    const [files, setFiles] = useState<any>([null]);
    const [noticeType, setNoticeType] = useState<string>();
    const [noticeDetailType, setNoticeDetailType] = useState<string>();
    const [dueDate, setDueDate] = useState<string>();
    const lTimetables = timeTables ? timeTables: res2?.data;

    const [resSendYN, setResSendYN] = useState<string>();
    const [resSendTime, setResSendTime] = useState('');
    const [disableSendTime, setDisableSendTime] = useState<any>(false) ;

    useEffect(() => {
        if (event) {
            execute(getSubjects2({
                semesterCourseCode: event.resource.semesterCourseCode,
                timetableSeq: event.resource.timetableSeq,
                timetableCode: event.resource.timetableCode,
            }));

            const todayDate = moment(new Date()).format('YYYY-MM-DD');
            if(moment(event?.start) < moment(todayDate) || moment(event?.start) > moment(todayDate).add(30, 'days')) {
                setDisableSendTime(true);
            } else {
                setDisableSendTime(false);
            }
        }
    }, [event]);

    useEffect(() => {
        if(dataList.get(uniqueNo)) {
            setNoticeType(dataList.get(uniqueNo)?.noticeType);
            setNoticeDetailType(dataList.get(uniqueNo)?.noticeDetailType);
            setTitle(dataList.get(uniqueNo)?.title);
            setContent(dataList.get(uniqueNo)?.content);
            setSubjectCode(dataList.get(uniqueNo)?.subjectCode);
            setDueDate(dataList.get(uniqueNo)?.dueDate);
            setAlarmYN(dataList.get(uniqueNo)?.alarmYN);
            setSms(dataList.get(uniqueNo)?.sms);
            setFiles(dataList.get(uniqueNo)?.files);
        }

        if(!timeTables) {
            if (chosenClass?.classCode) {
                execute2(getTimetables(chosenClass.classCode));            
            }
        }

        setResSendYN('N');
    }, [])

    const onSetFile = (index: number, file: any) => {
        const _files = [...files];
        _files[index] = file;
        setFiles(_files);

        let tempRowData = dataList.get(uniqueNo);
        let tempData : Map<number, ICreateNoticeInfo> = new Map<number, ICreateNoticeInfo>();
        if(tempRowData){
            tempRowData.files = _files;
            tempData.set(uniqueNo, tempRowData);
        }

        setEachData(tempData);
    }
    
    const onAddFile = () => {
        const _files = [...files];
        _files.push(null);
        setFiles(_files);

        let tempRowData = dataList.get(uniqueNo);
        let tempData : Map<number, ICreateNoticeInfo> = new Map<number, ICreateNoticeInfo>();
        if(tempRowData){
            tempRowData.files = _files;
            tempData.set(uniqueNo, tempRowData);
        }
    }
    
    const onDeleteFile = (index: number) => {
        const _files = [...files];
        _files.splice(index, 1);
        setFiles(_files);

        let tempRowData = dataList.get(uniqueNo);
        let tempData : Map<number, ICreateNoticeInfo> = new Map<number, ICreateNoticeInfo>();
        if(tempRowData){
            tempRowData.files = _files;
            tempData.set(uniqueNo, tempRowData);
        }
    }

    let firstNoticeStyle = (uniqueNo === 1) ? {borderTop: '2px solid #f9f9f9'} : {};

    const disabledHours = () => {
        const sendDate = moment(event?.start).format('YYYY-MM-DD');
        const currentDate = moment(new Date());
        const hourArray = Array.from({ length: 24 }, (v, k) => k);
        if (sendDate === currentDate.format('YYYY-MM-DD')) {
            return hourArray.filter((v) => v < currentDate.hour());
        } else {
            return [];
        }
    };

    return(
        <>
            {isLoading ? <Loader /> : null}
            <ErrorResponse error={error} />

            <div className="comm-table__area rowType edit mt-0">
                <table style={firstNoticeStyle}>
                    <colgroup>
                        <col width="150px" />
                        <col width="*" />
                        <col width="150px" />
                        <col width="*" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <th className="text-center">{t('statistics.homework.column4')}</th>
                            <td>
                                <div className="w-150p">
                                    <Select
                                        className="w-100"
                                        placeholder={t('common.button.select')}
                                        value={noticeType}
                                        onChange={value => {
                                            setNoticeType(value);

                                            let tempRowData = dataList.get(uniqueNo);
                                            let tempData : Map<number, ICreateNoticeInfo> = new Map<number, ICreateNoticeInfo>();
                                            if(tempRowData){
                                                tempRowData.noticeType = value;
                                                tempData.set(uniqueNo, tempRowData);
                                            }

                                            setEachData(tempData);
                                        }}
                                    >
                                        {
                                            NT0001?.map((item: any) => {
                                                return (
                                                    <Select.Option
                                                        key={item.detailCode}
                                                        value={item.detailCode}
                                                    >
                                                        {item.korName}
                                                    </Select.Option>
                                                )
                                            })
                                        }
                                    </Select>
                                </div>
                            </td>
                            <th className="text-center">{t('class.class.column90') + '/' + t('student.student.column88')}</th>
                            <td>
                                {
                                    noticeType === 'HW' && 
                                    <div className="w-150p">
                                        <Select
                                        className="w-100"
                                        placeholder={t('common.button.select')}
                                        value={subjectCode}
                                        onChange={(value) => {
                                            let _classTimeSeq = res?.data?.find(item => item.subjectCode === value)?.classTimeSeq;
                                            setSubjectCode(value);

                                            let tempRowData = dataList.get(uniqueNo);
                                            let tempData : Map<number, ICreateNoticeInfo> = new Map<number, ICreateNoticeInfo>();
                                            if(tempRowData){
                                                tempRowData.classTimeSeq = _classTimeSeq;
                                                tempRowData.subjectCode = value;
                                                tempData.set(uniqueNo, tempRowData);
                                            }

                                            setEachData(tempData);
                                        }}
                                        >
                                        {res?.data.map((item) => (
                                            <Select.Option
                                            key={item.classTimeSeq + '_' + item.subjectCode}
                                            value={item.subjectCode}
                                            >
                                            {item.subjectName}
                                            </Select.Option>
                                        ))}
                                        </Select>
                                    </div>
                                }
                                {
                                    noticeType === 'AN' && 
                                    <div className="w-150p">
                                        <Select
                                        className="w-100"
                                        placeholder={t('common.button.select')}
                                        value={noticeDetailType}
                                        onChange={(value) => {
                                            const _classTimeSeq = 0;
                                            setNoticeDetailType(value);

                                            let tempRowData = dataList.get(uniqueNo);
                                            let tempData : Map<number, ICreateNoticeInfo> = new Map<number, ICreateNoticeInfo>();
                                            if(tempRowData){
                                                tempRowData.classTimeSeq = _classTimeSeq;
                                                tempRowData.noticeDetailType = value;
                                                tempData.set(uniqueNo, tempRowData);
                                            }

                                            setEachData(tempData);
                                        }}
                                        >
                                        {   
                                                NT0002?.map((item: any) => {
                                                    return (
                                                        <Option
                                                            key={item.detailCode}
                                                            value={item.detailCode}
                                                        >
                                                            {item.korName}
                                                        </Option>
                                                    )
                                                })
                                            }
                                        </Select>
                                    </div>
                                }
                                {
                                    (noticeType !== 'HW' && noticeType !== 'AN') &&
                                    <div className="w-150p">
                                        <Select
                                        className="w-100"
                                        placeholder={t('common.button.select')}
                                        disabled={true}
                                        />
                                    </div>
                                }
                            </td>
                        </tr>
                        <tr>
                            <th className="text-center">{t('class.class.column91')}</th>
                            <td colSpan={3}>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={title}
                                    onChange={e => {
                                        setTitle(e.target.value);

                                        let tempRowData = dataList.get(uniqueNo);
                                        let tempData : Map<number, ICreateNoticeInfo> = new Map<number, ICreateNoticeInfo>();
                                        if(tempRowData){
                                            tempRowData.title = e.target.value;
                                            tempData.set(uniqueNo, tempRowData);
                                        }

                                        setEachData(tempData);
                                    }}
                                />
                            </td>
                        </tr>
                        <tr>
                            <th className="text-center">{t('class.class.column92')}</th>
                            <td colSpan={3}>
                            <textarea
                                rows={8}
                                value={content}
                                onChange={e => {
                                    setContent(e.target.value);

                                    let tempRowData = dataList.get(uniqueNo);
                                    let tempData : Map<number, ICreateNoticeInfo> = new Map<number, ICreateNoticeInfo>();
                                    if(tempRowData){
                                        tempRowData.content = e.target.value;
                                        tempData.set(uniqueNo, tempRowData);
                                    }

                                    setEachData(tempData);
                                }}
                            />
                            </td>
                        </tr>
                        <tr>
                            <th className="text-center">{t('class.notice.duedate')}</th>
                            <td colSpan={3}>
                                <div className="date-picker__area">
                                <DatePicker
                                    value={dueDate ? moment(dueDate) : moment()}
                                    onChange={(e) => {
                                        if (e === null) {
                                            setDueDate('');
                                        } else {
                                            setDueDate(moment(e).format('YYYYMMDD'));
                                        }

                                        let tempRowData = dataList.get(uniqueNo);
                                        let tempData : Map<number, ICreateNoticeInfo> = new Map<number, ICreateNoticeInfo>();
                                        if(tempRowData){
                                            if (e === null) {
                                                tempRowData.dueDate = '';
                                            } else {
                                                tempRowData.dueDate = moment(e).format('YYYYMMDD');
                                            }
                                            tempData.set(uniqueNo, tempRowData);
                                        }

                                        setEachData(tempData);
                                    }}
                                    format={['YYYY-MM-DD', 'YYYYMMDD']}
                                    disabledDate={current => {
                                        if(noticeType === 'HW') {
                                            const timetable = lTimetables?.find(item => item.srtDate === moment(current).format('YYYYMMDD'));
                                            return timetable ? false : true;
                                        } else {
                                            return false;
                                        }
                                    }}
                                />
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th className="text-center">{t('archive.exam.column7')}</th>
                            <td colSpan={3}>
                            {
                                files.length > 0
                                ? files.map((file: any, index: number) => (
                                    <div className="flex mb-2" key={index}>
                                    <FileUpload
                                        file={files[index]}
                                        setFile={(file: any) => onSetFile(index, file)}
                                    />
                                    <div className="comm-btn__area">
                                        <Button
                                        className="btn-basic small gray ml-2"
                                        onClick={() => onDeleteFile(index)}
                                        text={t('common.button.delete')}
                                        />
                                    </div>
                                    </div>
                                ))
                                : null
                            }
                            <div className="comm-btn__area">
                                <Button
                                    className="btn-basic pink-line"
                                    onClick={onAddFile}
                                    text={t('common.button.add')}
                                />              
                            </div>
                            </td>
                        </tr>
                        <tr>
                        <th className="text-center">{t('class.class.column94')}</th>
                            <td className="pl-4">
                            <Radio
                                checked={alarmYN === 'Y'}
                                onChange={() => {
                                    setAlarmYN('Y');

                                    let tempRowData = dataList.get(uniqueNo);
                                    let tempData : Map<number, ICreateNoticeInfo> = new Map<number, ICreateNoticeInfo>();
                                    if(tempRowData){
                                        tempRowData.alarmYN = 'Y';
                                        tempData.set(uniqueNo, tempRowData);
                                    }
                                    setEachData(tempData);
                                }}
                                text={t('common.option.yes')}
                            />
                            <Radio
                                className="ml-4"
                                checked={alarmYN === 'N'}
                                onChange={() => {
                                    setAlarmYN('N');

                                    let tempRowData = dataList.get(uniqueNo);
                                    let tempData : Map<number, ICreateNoticeInfo> = new Map<number, ICreateNoticeInfo>();
                                    if(tempRowData){
                                        tempRowData.alarmYN = 'N';
                                        tempData.set(uniqueNo, tempRowData);
                                    }
                                    setEachData(tempData);
                                }}
                                text={t('common.option.no')}
                            />
                            </td>
                            <th className="text-center">{t('class.class.column95')}</th>
                            <td className="pl-4" colSpan={3}>
                                <Radio
                                checked={!sms}
                                onChange={() => {
                                    setSms(false);

                                    let tempRowData = dataList.get(uniqueNo);
                                    let tempData : Map<number, ICreateNoticeInfo> = new Map<number, ICreateNoticeInfo>();
                                    if(tempRowData){
                                        tempRowData.sms = false;
                                        tempData.set(uniqueNo, tempRowData);
                                    }
                                    setEachData(tempData);
                                }}
                                text={t('class.class.option4')}
                                disabled={alarmYN === 'N'}
                                />
                                <Radio
                                className="ml-4"
                                checked={sms}
                                onChange={() => {
                                    setSms(true);

                                    let tempRowData = dataList.get(uniqueNo);
                                    let tempData : Map<number, ICreateNoticeInfo> = new Map<number, ICreateNoticeInfo>();
                                    if(tempRowData){
                                        tempRowData.sms = true;
                                        tempData.set(uniqueNo, tempRowData);
                                    }
                                    setEachData(tempData);
                                }}
                                text={t('class.class.option5')}
                                disabled={alarmYN === 'N'}
                                />
                            </td>
                        </tr>
                        <tr>
                            <th className="text-center">{t('class.notice.label2')}</th>
                            <td className="pl-4" colSpan={3}>
                                <div className='comm-gap'>
                                    <Radio
                                        checked={resSendYN==='N'}
                                        onChange={() => {
                                            setResSendYN('N');
                                            
                                            let tempRowData = dataList.get(uniqueNo);
                                            let tempData : Map<number, ICreateNoticeInfo> = new Map<number, ICreateNoticeInfo>();
                                            if(tempRowData){
                                                tempRowData.resvYn = 'N';
                                                tempData.set(uniqueNo, tempRowData);
                                            }
                                            setEachData(tempData);
                                        }}
                                        text={t('class.notice.label3')}
                                    />
                                    <Radio
                                        className="ml-4"
                                        checked={resSendYN==='Y'}
                                        onChange={() => {
                                            setResSendYN('Y');

                                            let tempRowData = dataList.get(uniqueNo);
                                            let tempData : Map<number, ICreateNoticeInfo> = new Map<number, ICreateNoticeInfo>();
                                            if(tempRowData){
                                                tempRowData.resvYn = 'Y';
                                                tempData.set(uniqueNo, tempRowData);
                                            }
                                            setEachData(tempData);
                                        }}
                                        text={t('class.notice.label4')}
                                        disabled={disableSendTime}
                                    />
                                    <input type="text" className="form-control w-90p ml-3" value={moment(event?.start).format('YYYY.MM.DD')} disabled={true} />
                                    <div className="time-picker__area">
                                        <CustomTimePicker
                                            value={resSendTime}
                                            onSelect={(value) => {
                                                if (value) {
                                                    setResSendTime(moment(value).format('HH:mm'));

                                                    let tempRowData = dataList.get(uniqueNo);
                                                    let tempData : Map<number, ICreateNoticeInfo> = new Map<number, ICreateNoticeInfo>();
                                                    if(tempRowData){
                                                        tempRowData.resvDateTime = moment(event?.start).format('YYYY-MM-DD') + ' ' + moment(value).format('HH:mm') + ':00';
                                                        tempData.set(uniqueNo, tempRowData);
                                                    }
                                                    setEachData(tempData);
                                                } else {
                                                    setResSendTime('');
                                                }                       
                                            }}
                                            minuteStep={30}
                                            disabledHours={disabledHours}
                                            disabled={disableSendTime}
                                        />
                                    </div>
                                </div>
                                {resSendYN==='Y' &&
                                    <div className="mt-2 notice-high">
                                        {t('class.notice.message6')}<br/>
                                        {t('class.notice.message7')}<br/>
                                        {t('class.notice.message8')}
                                    </div>
                                }
                                {(resSendYN==='N' && disableSendTime) &&
                                    <div className="mt-2 notice-high">
                                        {t('class.notice.message7')}<br/>
                                    </div>
                                }
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </>
    )
}

export default NoticeMultilEditor;